module.exports = __webpack_public_path__ + "static/media/tz.ed1c43d0.svg";